"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactTableScopeKey = exports.MAX_TABLE_FILTERS = exports.MAX_TABLE_COLUMNS = exports.TablePreferenceTableKey = void 0;
var TablePreferenceTableKey;
(function (TablePreferenceTableKey) {
    TablePreferenceTableKey["Payments"] = "Payments";
    TablePreferenceTableKey["Contacts"] = "contacts";
    TablePreferenceTableKey["Members"] = "members";
    TablePreferenceTableKey["Lists"] = "lists";
    TablePreferenceTableKey["PostMailDeliveries"] = "postMailDeliveries";
    TablePreferenceTableKey["Payouts"] = "payouts";
    TablePreferenceTableKey["TreasuryTransactions"] = "treasuryTransactions";
    TablePreferenceTableKey["Companies"] = "companies";
    TablePreferenceTableKey["NewsletterForms"] = "newsletterForms";
    TablePreferenceTableKey["BulkEmails"] = "bulkEmails";
    TablePreferenceTableKey["PostMailRecipients"] = "postMailRecipients";
    TablePreferenceTableKey["EmailRecipients"] = "emailRecipients";
    TablePreferenceTableKey["SmsRecipients"] = "smsRecipients";
    TablePreferenceTableKey["TaxReceipts"] = "taxReceipts";
    TablePreferenceTableKey["AuctionBids"] = "auctionBids";
    TablePreferenceTableKey["Fulfillment"] = "fulfillment";
    TablePreferenceTableKey["GuestList"] = "guestList";
    TablePreferenceTableKey["Transactions"] = "transactions";
    TablePreferenceTableKey["PostMailAudienceRecipients"] = "postMailAudienceRecipients";
})(TablePreferenceTableKey || (exports.TablePreferenceTableKey = TablePreferenceTableKey = {}));
exports.MAX_TABLE_COLUMNS = 80;
exports.MAX_TABLE_FILTERS = 20;
// Contacts table preferences saved per contact list type, apart from the main Contacts page.
var ContactTableScopeKey;
(function (ContactTableScopeKey) {
    ContactTableScopeKey["StaticList"] = "staticList";
    ContactTableScopeKey["FilterList"] = "filterList";
    ContactTableScopeKey["MemberList"] = "memberList";
    ContactTableScopeKey["CreateList"] = "createList";
    ContactTableScopeKey["AutomaticListPreview"] = "automaticListPreview";
    ContactTableScopeKey["PickerEmail"] = "picker-email";
    ContactTableScopeKey["PickerPostal"] = "picker-postal";
})(ContactTableScopeKey || (exports.ContactTableScopeKey = ContactTableScopeKey = {}));
